import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkadarshancabn() {



  const cardData = {




keyword: "Pune to Konkan Darshan Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Konkan Darshan Cab Service for families, couples, senior citizens, friends, and groups planning a scenic coastal journey through Konkan. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way trips, round trips, multi-day holidays, beach tours, temple visits, family vacations, and customized Konkan sightseeing plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes long-distance Konkan travel convenient and comfortable. Travelers can customize their route to explore beaches, forts, temples, waterfalls, coastal villages, scenic viewpoints, and popular destinations across the Konkan region according to their preferred schedule.",

topPlaces: [
  {
    title: "Alibaug",
    description: "Alibaug is a popular Konkan destination known for beautiful beaches, coastal landscapes, historic forts, and relaxing seaside surroundings. Families and groups from Pune frequently choose Alibaug for weekend holidays and coastal sightseeing. Garud Cab Service provides comfortable private cabs with flexible travel plans for exploring Alibaug and nearby attractions."
  },
  {
    title: "Murud",
    description: "Murud is a scenic coastal destination known for its beach, peaceful surroundings, and proximity to the historic Murud-Janjira Fort. Travelers can enjoy a combination of seaside relaxation and heritage sightseeing during their Konkan journey. Customers can include Murud in a customized Pune to Konkan Darshan cab itinerary with convenient chauffeur-driven transportation."
  },
  {
    title: "Harihareshwar",
    description: "Harihareshwar is a popular religious and coastal destination known for the Harihareshwar Temple, peaceful beaches, and surrounding hills. It is suitable for families and devotees looking for a combination of pilgrimage and seaside travel. Garud Cab Service provides comfortable cabs for travelers planning a relaxed multi-day Konkan tour."
  },
  {
    title: "Shrivardhan",
    description: "Shrivardhan is a peaceful Konkan town surrounded by beaches, coconut plantations, greenery, and traditional coastal landscapes. It is ideal for travelers seeking a quieter seaside experience away from busy tourist centers. Customers traveling from Pune can book a private cab and include Shrivardhan as part of their customized Konkan Darshan route."
  },
  {
    title: "Dapoli",
    description: "Dapoli is a popular coastal destination known for beaches, temples, greenery, and scenic countryside. It offers a variety of experiences for families, couples, and groups planning a longer Konkan vacation. Garud Cab Service can arrange comfortable chauffeur-driven transportation from Pune with flexible sightseeing stops around Dapoli."
  },
  {
    title: "Ganpatipule",
    description: "Ganpatipule is one of Maharashtra's well-known coastal pilgrimage destinations, famous for the Swayambhu Ganpati Temple and beautiful Arabian Sea coastline. Devotees and tourists frequently include Ganpatipule in Konkan road trips. Customers can book a spacious cab from Pune for comfortable long-distance travel and customized temple and beach sightseeing."
  },
  {
    title: "Ratnagiri",
    description: "Ratnagiri is an important Konkan city known for beaches, forts, temples, mango orchards, and historic attractions. Travelers can explore the coastal culture and heritage of the region while visiting destinations around the city. Garud Cab Service offers flexible cab arrangements for families and groups planning a multi-day Pune to Konkan journey."
  },
  {
    title: "Tarkarli",
    description: "Tarkarli is a scenic coastal destination in southern Konkan known for clear waters, beaches, water activities, and peaceful seaside surroundings. It is especially suitable for travelers planning an extended coastal vacation. Customers can customize their Pune to Konkan Darshan cab route to include Tarkarli with comfortable vehicles and flexible travel schedules."
  },
  {
    title: "Malvan",
    description: "Malvan is a popular coastal town known for Sindhudurg Fort, beaches, traditional Malvani cuisine, and marine activities. It offers a combination of history, culture, and seaside experiences for visitors. Garud Cab Service provides private chauffeur-driven cabs for travelers from Pune who want to explore Malvan and nearby Konkan attractions."
  },
  {
    title: "Sindhudurg Fort",
    description: "Sindhudurg Fort is a historic sea fort built on an island near Malvan and is one of the most notable heritage attractions along the Konkan coast. Visitors can explore the fort while enjoying views of the Arabian Sea. Customers can include Sindhudurg Fort in a multi-day Konkan Darshan itinerary with convenient cab transportation between destinations."
  }
],




"services": [
{
"name": "Pune to Konkan Cab",
"description": "Book Pune to Konkan Cab for comfortable private transportation from Pune to the scenic Konkan region. The service is suitable for families, couples, groups, tourists, and travelers planning beach holidays, coastal sightseeing, temple visits, or a relaxed road trip."
},
{
"name": "Konkan Darshan Cab Pune",
"description": "Choose Konkan Darshan Cab Pune for convenient private transportation during a Konkan sightseeing journey. The service can be arranged for families, groups, and tourists visiting beaches, coastal attractions, temples, forts, and other popular destinations across the Konkan region."
},
{
"name": "Pune Konkan Tour Cab",
"description": "Book Pune Konkan Tour Cab for a comfortable road trip covering selected Konkan destinations according to your travel itinerary. Suitable vehicles and professional chauffeurs can be arranged for families, couples, friends, and groups planning a customized coastal holiday."
},
{
"name": "Konkan Sightseeing Cab Pune",
"description": "Choose Konkan Sightseeing Cab Pune for convenient travel between coastal attractions, beaches, temples, forts, and scenic locations. Private chauffeur-driven vehicles provide flexibility for travelers who want to explore multiple Konkan destinations during their trip."
},
{
"name": "Pune to Konkan Taxi Service",
"description": "Book Pune to Konkan Taxi Service for comfortable private travel from Pune to various Konkan destinations. Sedan, SUV, Innova, and larger vehicle options can be selected according to passenger count, luggage, itinerary, and overall travel requirements."
},
{
"name": "Konkan Darshan Taxi Pune",
"description": "Choose Konkan Darshan Taxi Pune for private transportation during a planned coastal sightseeing tour. The service is suitable for families, senior travelers, couples, and groups looking for convenient travel between beaches, temples, heritage attractions, and scenic Konkan locations."
},
{
"name": "Pune Coastal Tour Cab Konkan",
"description": "Book Pune Coastal Tour Cab Konkan for a private journey through the scenic coastal belt of Konkan. The service can support beach visits, sightseeing, local exploration, temple trips, and multi-day road travel with a vehicle selected according to your group size."
},
{
"name": "Konkan Trip Cab Pune",
"description": "Reserve Konkan Trip Cab Pune for comfortable transportation during a personal or family holiday in Konkan. Customers can plan one-way travel, round trips, sightseeing schedules, and multi-day journeys with suitable chauffeur-driven vehicles."
},
{
"name": "Pune Konkan Travel Cab",
"description": "Choose Pune Konkan Travel Cab for convenient private transportation throughout your coastal journey. The service is suitable for tourists, families, couples, and groups planning beach holidays, sightseeing trips, temple visits, and long-distance road travel."
},
{
"name": "Best Konkan Darshan Cab Pune",
"description": "Book the Best Konkan Darshan Cab Pune for a comfortable sightseeing experience supported by professional chauffeurs and well-maintained vehicles. The service can be planned around your preferred destinations, travel duration, passenger requirements, and sightseeing schedule."
},
{
"name": "SUV Konkan Cab Pune",
"description": "Choose SUV Konkan Cab Pune for spacious private transportation suitable for families and small groups traveling through Konkan. SUVs provide practical seating and luggage capacity for beach trips, sightseeing, long drives, and multi-day coastal tours."
},
{
"name": "Innova Konkan Cab Pune",
"description": "Book Innova Konkan Cab Pune for comfortable and spacious travel for families and groups exploring Konkan. The vehicle is suitable for longer road journeys, sightseeing itineraries, beach visits, temple tours, and trips requiring additional passenger and luggage space."
},
{
"name": "Sedan Konkan Cab Pune",
"description": "Choose Sedan Konkan Cab Pune for practical AC transportation suitable for couples, individuals, and small families. Sedan cars provide comfortable travel for Konkan road trips, sightseeing, beach holidays, personal visits, and short multi-day itineraries."
},
{
"name": "Konkan Tour Booking Pune",
"description": "Make Konkan Tour Booking Pune in advance to arrange private transportation according to your preferred travel dates and destinations. Customers can select suitable vehicles and plan one-day trips, weekend tours, or longer Konkan sightseeing itineraries."
},
{
"name": "Konkan Holiday Cab Pune",
"description": "Book Konkan Holiday Cab Pune for convenient transportation during a relaxing coastal vacation. The service is suitable for families, couples, and groups visiting beaches, scenic locations, temples, forts, seafood destinations, and other Konkan attractions."
},
{
"name": "Pune to Konkan Darshan Cab",
"description": "Choose Pune to Konkan Darshan Cab for private transportation designed around a Konkan sightseeing itinerary. Travelers can visit multiple destinations comfortably with professional chauffeur assistance and a vehicle selected according to their passenger and luggage requirements."
},
{
"name": "Pune to Konkan Cab Service",
"description": "Book Pune to Konkan Cab Service for reliable chauffeur-driven transportation from Pune to the Konkan region. The service can be arranged for family vacations, weekend trips, sightseeing tours, beach holidays, religious visits, and customized coastal journeys."
},
{
"name": "Pune to Konkan Taxi",
"description": "Choose Pune to Konkan Taxi for comfortable intercity transportation to destinations across the Konkan coast. Sedan, SUV, Innova, and other vehicle categories can be arranged for couples, families, tourists, and groups according to their travel plans."
},
{
"name": "Pune to Konkan Taxi Service",
"description": "Book Pune to Konkan Taxi Service for convenient private travel with flexible pickup and destination arrangements. The service is suitable for travelers planning coastal sightseeing, family holidays, weekend trips, religious tours, and multi-day Konkan road journeys."
},
{
"name": "Pune to Kokan Cab",
"description": "Reserve Pune to Kokan Cab for comfortable private transportation to the Konkan coastal region. Professional chauffeurs and suitable AC vehicles can be arranged for individuals, couples, families, and groups traveling for holidays, sightseeing, and personal trips."
},
{
"name": "Pune to Kokan Darshan Cab",
"description": "Choose Pune to Kokan Darshan Cab for a private sightseeing journey covering selected coastal attractions. The service provides convenient transportation for families and tourists visiting beaches, temples, forts, scenic viewpoints, and traditional Konkan destinations."
},
{
"name": "Pune to Konkan Cabs",
"description": "Book Pune to Konkan Cabs for private group transportation with vehicle options suited to different passenger requirements. The service is useful for family holidays, group tours, weekend trips, beach visits, sightseeing, and longer coastal road journeys."
},
{
"name": "Pune Konkan Tour by Cab",
"description": "Plan a Pune Konkan Tour by Cab for flexible private travel across multiple coastal destinations. Travelers can customize the itinerary according to trip duration, sightseeing preferences, passenger count, and preferred vehicle category."
},
{
"name": "Konkan Darshan Cab from Pune",
"description": "Book Konkan Darshan Cab from Pune for convenient transportation during a planned coastal sightseeing tour. The service can accommodate families, couples, senior citizens, and groups visiting beaches, temples, forts, and scenic attractions across Konkan."
},
{
"name": "Pune to Konkan Car Rental",
"description": "Choose Pune to Konkan Car Rental for private chauffeur-driven transportation during your coastal journey. Vehicle options can be selected according to group size, luggage, travel duration, and itinerary requirements for one-day or multi-day Konkan trips."
},
{
"name": "Pune to Konkan Tour Package",
"description": "Book a Pune to Konkan Tour Package for organized private transportation covering your selected coastal destinations. The journey can be planned around family holidays, sightseeing, beach visits, temple tours, weekend travel, or extended Konkan vacations."
},
{
"name": "Konkan Darshan Tour Package from Pune",
"description": "Choose a Konkan Darshan Tour Package from Pune for a convenient multi-destination coastal journey with private cab transportation. The itinerary can be customized for sightseeing, beaches, temples, forts, scenic locations, and family travel."
},
{
"name": "Pune to Konkan Road Trip",
"description": "Plan a Pune to Konkan Road Trip with a comfortable private cab and professional chauffeur. The service provides flexibility for travelers who want to explore coastal roads, beaches, local attractions, scenic stops, and multiple Konkan destinations at their preferred pace."
},
{
"name": "Pune to Konkan Sightseeing Cab",
"description": "Book Pune to Konkan Sightseeing Cab for private transportation between different coastal attractions. The service is suitable for tourists and families planning visits to beaches, temples, forts, viewpoints, markets, and other popular destinations during their Konkan trip."
},
{
"name": "Pune to Konkan 2 Days Cab Package",
"description": "Choose Pune to Konkan 2 Days Cab Package for a short coastal getaway with private transportation throughout the planned itinerary. It is suitable for weekend travelers, couples, families, and groups looking to cover selected Konkan destinations comfortably."
},
{
"name": "Pune to Konkan 2 Days 1 Night Tour",
"description": "Book Pune to Konkan 2 Days 1 Night Tour for a compact coastal holiday with private cab transportation. The itinerary can include selected beaches, temples, scenic attractions, and local sightseeing while allowing travelers to return to Pune after an overnight stay."
},
{
"name": "Pune to Konkan 3 Days Cab Package",
"description": "Plan a Pune to Konkan 3 Days Cab Package for a relaxed multi-day road trip covering several coastal destinations. Private transportation makes it convenient for families and groups to manage sightseeing, beach visits, temple stops, and local exploration."
},
{
"name": "Pune to Konkan 3 Days 2 Nights Package",
"description": "Choose Pune to Konkan 3 Days 2 Nights Package for an extended coastal holiday with chauffeur-driven transportation. The trip can be customized to include beaches, scenic locations, temples, forts, and other attractions according to your preferred itinerary."
},
{
"name": "Pune to Konkan 4 Days Cab Package",
"description": "Book Pune to Konkan 4 Days Cab Package for a longer coastal journey with private transportation throughout the trip. It is suitable for families, groups, and tourists who want more time to explore multiple Konkan destinations without rushing between locations."
},
{
"name": "Pune to Konkan 4 Days 3 Nights Tour",
"description": "Choose Pune to Konkan 4 Days 3 Nights Tour for a comfortable extended holiday covering multiple coastal attractions. A private cab allows travelers to customize sightseeing stops, beach visits, temple journeys, and scenic routes around their travel schedule."
},
{
"name": "Pune to Konkan 5 Days Cab Package",
"description": "Book Pune to Konkan 5 Days Cab Package for a comprehensive coastal road trip with private chauffeur-driven transportation. The longer itinerary is suitable for families and groups who want to explore several Konkan destinations at a comfortable pace."
},
{
"name": "Pune to Konkan 5 Days 4 Nights Tour",
"description": "Plan Pune to Konkan 5 Days 4 Nights Tour for an extended vacation featuring coastal sightseeing, beach visits, temples, forts, and scenic destinations. Private cab transportation provides flexibility for travelers to organize the journey around their preferred attractions."
},
{
"name": "Pune to Konkan 6 Days Tour Package",
"description": "Choose Pune to Konkan 6 Days Tour Package for a detailed multi-day coastal journey covering a wider selection of destinations. The private cab service is suitable for families, groups, and travelers who want a relaxed itinerary with sufficient time for sightseeing and local exploration."
},
{
"name": "Pune to Konkan Weekend Trip by Cab",
"description": "Book Pune to Konkan Weekend Trip by Cab for a convenient short holiday away from Pune. The service is suitable for couples, families, and friends planning beach visits, coastal sightseeing, scenic drives, and a quick Konkan getaway."
},
{
"name": "Pune to Konkan One-Day Trip",
"description": "Choose Pune to Konkan One-Day Trip for a planned private road journey covering selected destinations within a limited schedule. The cab can be arranged for sightseeing, beach visits, temple travel, and other short coastal excursions."
},
{
"name": "Pune to Konkan Long Weekend Package",
"description": "Book Pune to Konkan Long Weekend Package for an extended coastal getaway with private transportation. The itinerary can be customized to cover multiple beaches, sightseeing attractions, temples, forts, and scenic locations during the available holiday period."
},
{
"name": "Pune to Konkan Honeymoon Cab Package",
"description": "Choose Pune to Konkan Honeymoon Cab Package for private and comfortable transportation during a romantic coastal getaway. Couples can plan a flexible itinerary covering scenic beaches, peaceful destinations, sightseeing spots, and relaxing stays across Konkan."
},
{
"name": "Pune to Konkan Family Tour Package",
"description": "Book Pune to Konkan Family Tour Package for comfortable private transportation designed around family travel requirements. Spacious vehicles can be arranged for parents, children, and groups carrying luggage while visiting beaches, temples, forts, and scenic coastal attractions."
}
],
"tableData": [
["Pune to Konkan Cab", "Konkan Darshan Cab Pune"],
["Pune Konkan Tour Cab", "Konkan Sightseeing Cab Pune"],
["Pune to Konkan Taxi Service", "Konkan Darshan Taxi Pune"],
["Pune Coastal Tour Cab Konkan", "Konkan Trip Cab Pune"],
["Pune Konkan Travel Cab", "Best Konkan Darshan Cab Pune"],
["SUV Konkan Cab Pune", "Innova Konkan Cab Pune"],
["Sedan Konkan Cab Pune", "Konkan Tour Booking Pune"],
["Konkan Holiday Cab Pune", "Pune to Konkan Darshan Cab"],
["Pune to Konkan Cab Service", "Pune to Konkan Taxi"],
["Pune to Konkan Taxi Service", "Pune to Kokan Cab"],
["Pune to Kokan Darshan Cab", "Pune to Konkan Cabs"],
["Pune Konkan Tour by Cab", "Konkan Darshan Cab from Pune"],
["Pune to Konkan Car Rental", "Pune to Konkan Tour Package"],
["Konkan Darshan Tour Package from Pune", "Pune to Konkan Road Trip"],
["Pune to Konkan Sightseeing Cab", "Pune to Konkan 2 Days Cab Package"],
["Pune to Konkan 2 Days 1 Night Tour", "Pune to Konkan 3 Days Cab Package"],
["Pune to Konkan 3 Days 2 Nights Package", "Pune to Konkan 4 Days Cab Package"],
["Pune to Konkan 4 Days 3 Nights Tour", "Pune to Konkan 5 Days Cab Package"],
["Pune to Konkan 5 Days 4 Nights Tour", "Pune to Konkan 6 Days Tour Package"],
["Pune to Konkan Weekend Trip by Cab", "Pune to Konkan One-Day Trip"],
["Pune to Konkan Long Weekend Package", "Pune to Konkan Honeymoon Cab Package"],
["Pune to Konkan Family Tour Package", "Konkan Darshan Cab Pune"]
]
,



whychoose: [
  {
    WhyChooseheading: "Pune to Konkan Darshan Cab for Scenic Coastal Tours",
    WhyChoosedescription: "A private cab makes a Konkan Darshan journey from Pune convenient for families, friends, couples, and groups who want to explore coastal destinations, beaches, temples, forts, and scenic locations at their own pace."
  },
  {
    WhyChooseheading: "Flexible Pickup from Pune",
    WhyChoosedescription: "Travellers can begin the tour from their home, hotel, office, residential society, or another preferred location in Pune, making it easier to plan the starting point according to the group schedule."
  },
  {
    WhyChooseheading: "Comfortable Travel for Families & Groups",
    WhyChoosedescription: "Families, senior citizens, couples, and groups can select a suitable vehicle based on passenger count, luggage requirements, and comfort preferences for a multi-destination coastal journey."
  },
  {
    WhyChooseheading: "Ideal for Konkan Sightseeing",
    WhyChoosedescription: "The private cab can be used for exploring beaches, coastal towns, temples, forts, viewpoints, local attractions, and other destinations included in your preferred Konkan Darshan itinerary."
  },
  {
    WhyChooseheading: "Customizable Multi-Day Tour Plans",
    WhyChoosedescription: "Travellers can plan a short getaway or a longer Konkan tour according to available days, preferred destinations, hotel stays, sightseeing interests, and the desired return schedule."
  },
  {
    WhyChooseheading: "Convenient for Family & Religious Tours",
    WhyChoosedescription: "Konkan Darshan can combine sightseeing with temple visits and family travel, allowing everyone to remain together while moving between multiple destinations during the tour."
  },
  {
    WhyChooseheading: "Round-Trip Cab for Complete Tours",
    WhyChoosedescription: "A round-trip private cab provides transportation from Pune through the selected Konkan destinations and back, making it suitable for planned holidays, sightseeing tours, and extended coastal trips."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Pune pickup location, preferred Konkan destinations, travel dates, passenger details, luggage requirements, vehicle preference, and expected trip duration with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Konkan Darshan Cab Service?",
    answer: "Yes, Garud Cab Service provides private cab services from Pune for Konkan Darshan tours covering coastal destinations, beaches, temples, forts, sightseeing locations, and family travel."
  },
  {
    question: "Can I customize my Pune to Konkan Darshan itinerary?",
    answer: "Yes, the tour can be planned according to your preferred Konkan destinations, travel dates, number of days, sightseeing requirements, hotel plans, and return schedule."
  },
  {
    question: "Can I book a round-trip cab for Konkan Darshan?",
    answer: "Yes, round-trip cab arrangements can be planned for travellers who want transportation from Pune through their selected Konkan destinations and back to Pune."
  },
  {
    question: "Is Konkan Darshan suitable for families?",
    answer: "Yes, a private cab is suitable for families and groups who want to travel together, carry luggage conveniently, and explore multiple destinations without changing vehicles."
  },
  {
    question: "Can I visit beaches during the Konkan Darshan tour?",
    answer: "Yes, beaches and other coastal attractions can be included in the itinerary depending on your preferred destinations, available travel time, and overall tour plan."
  },
  {
    question: "Can the Konkan tour include temple visits?",
    answer: "Yes, religious destinations and temples can be included along with sightseeing locations according to your preferred pilgrimage and travel itinerary."
  },
  {
    question: "Can I book a multi-day Konkan Darshan cab?",
    answer: "Yes, private cab arrangements can be planned for multi-day Konkan tours based on your destinations, travel duration, sightseeing schedule, and return requirements."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I carry luggage during the Konkan Darshan tour?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be shared while making the booking."
  },
  {
    question: "How can I book a Pune to Konkan Darshan Cab?",
    answer: "Share your Pune pickup location, preferred Konkan destinations, travel dates, passenger details, luggage requirements, vehicle preference, and expected trip duration with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Patil",
    feedback: "Our family planned a Konkan Darshan from Pune and selected a private cab for the complete trip. Travelling together made it easier to manage our luggage and visit different coastal destinations.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Joshi",
    feedback: "We arranged a multi-day Konkan tour with friends and appreciated having a private vehicle throughout the journey. It gave us more flexibility with sightseeing and our travel schedule.",
    rating: 5
  }
];












  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-konkan-darshan-cab.webp",
  "description": "Book Pune to Konkan Darshan Cab with Garud Cab for comfortable and reliable coastal travel. Plan a memorable Konkan tour from Pune with dedicated cab and taxi services for sightseeing, beaches, temples, family holidays, weekend trips, and coastal exploration. Choose Sedan, Ertiga, SUV, Innova, or Innova Crysta vehicles with flexible travel options for families and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-konkan-darshan-cab"
  }
};



  return (
    <div>



<Helmet>
  <title>Pune to Konkan Darshan Cab | Konkan Tour & Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Konkan Darshan Cab with Garud Cab for comfortable coastal tours, sightseeing, beach trips, temple visits, and family holidays. Get reliable Konkan taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune to Konkan Cab, Konkan Darshan Cab Pune, Pune Konkan Tour Cab, Konkan Sightseeing Cab Pune, Pune to Konkan Taxi Service, Konkan Darshan Taxi Pune, Pune Coastal Tour Cab Konkan, Konkan Trip Cab Pune, Pune Konkan Travel Cab, Best Konkan Darshan Cab Pune, SUV Konkan Cab, Konkan Tour Package from Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokonkadarshancabn;